(() => {
  const hook = document.querySelector('[data-ag-olfacto-hook]');
  if (!hook) return;

  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const stickyBar = document.querySelector('[data-ag-sticky-buy]');
  const stickyButton = stickyBar?.querySelector('[data-ag-sticky-submit]');
  const stickyPrice = stickyBar?.querySelector('[data-ag-sticky-price]');
  const stickyAvailableLabel = hook.dataset.agStickyAvailableLabel || 'Ajouter mon coffret';
  const stickyUnavailableLabel = hook.dataset.agStickyUnavailableLabel || 'Indisponible';

  root.classList.add('ag-olfacto-page');

  // Preserve an alternate product template only while it is being previewed.
  // Once the template is assigned to the product, Shopify's native URLs are left untouched.
  const previewView = new URLSearchParams(window.location.search).get('view');
  if (previewView === 'bijou-olfacto' && !window.__agOlfactoPreviewViewInstalled) {
    window.__agOlfactoPreviewViewInstalled = true;

    const preservePreviewView = (value) => {
      if (!value) return value;
      try {
        const url = new URL(String(value), window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/')) return value;
        url.searchParams.set('view', previewView);
        return url.href;
      } catch (_error) {
        return value;
      }
    };

    const nativeFetch = window.fetch.bind(window);
    window.fetch = (input, init) => {
      if (typeof input === 'string' || input instanceof URL) {
        return nativeFetch(preservePreviewView(input), init);
      }
      if (input instanceof Request) {
        return nativeFetch(new Request(preservePreviewView(input.url), input), init);
      }
      return nativeFetch(input, init);
    };

    const nativeReplaceState = window.history.replaceState.bind(window.history);
    window.history.replaceState = (state, unused, url) =>
      nativeReplaceState(state, unused, preservePreviewView(url));
  }

  if (!reduceMotion) {
    root.classList.add('ag-olfacto-motion-ready');
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    document.querySelectorAll('.ag-olfacto-reveal').forEach((element) => revealObserver.observe(element));
  }

  const normalize = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

  const getMainProductInfo = () =>
    document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('product-info');

  const getScentInputs = () =>
    Array.from(
      (getMainProductInfo() || document).querySelectorAll(
        'variant-selects input[type="radio"][data-option-name]'
      )
    ).filter((input) => {
      const optionName = normalize(input.dataset.optionName);
      const isEssentialOil = optionName.includes('huile') && optionName.includes('essentielle');
      const isNaturalPerfume = optionName.includes('parfum') && optionName.includes('naturel');
      return isEssentialOil || isNaturalPerfume || optionName.includes('senteur');
    });

  const getScentCards = () =>
    Array.from(document.querySelectorAll('[data-ag-scent-value], [data-ag-scent-key]'));

  const getScentKey = (value) => normalize(value).split(':')[0].trim();

  const findScentInputForCard = (card) =>
    getScentInputs().find((candidate) => {
      if (card.dataset.agScentValue) {
        return normalize(candidate.value) === normalize(card.dataset.agScentValue);
      }
      return getScentKey(candidate.value) === getScentKey(card.dataset.agScentKey);
    });

  const updateChoiceLabel = (card, isSelected) => {
    const label = card.querySelector('[data-ag-scent-choice-label]');
    if (!label) return;
    const labelText = isSelected
      ? card.dataset.agSelectedLabel || 'Senteur sélectionnée'
      : card.dataset.agUnselectedLabel || 'Choisir cette senteur';
    const labelNode = Array.from(label.childNodes).find(
      (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
    );
    if (labelNode) labelNode.textContent = `${labelText} `;
  };

  const syncScentCards = () => {
    const selectedInput = getScentInputs().find((input) => input.checked);
    const selectedValue = selectedInput?.value;

    getScentCards().forEach((card) => {
      const matchingInput = findScentInputForCard(card);
      const exactValueMatches =
        card.dataset.agScentValue && normalize(card.dataset.agScentValue) === normalize(selectedValue);
      const keyMatches = card.dataset.agScentKey && getScentKey(card.dataset.agScentKey) === getScentKey(selectedValue);
      const isSelected = Boolean(selectedValue && (exactValueMatches || keyMatches));
      card.disabled = !matchingInput || matchingInput.disabled;
      card.setAttribute('aria-disabled', String(card.disabled));
      card.setAttribute('aria-pressed', String(isSelected));
      card.classList.toggle('is-selected', isSelected);
      updateChoiceLabel(card, isSelected);
    });

    document.querySelectorAll('[data-ag-selected-synergy]').forEach((summary) => {
      const nextSummary = selectedValue || 'Duo à sélectionner';
      if (summary.textContent !== nextSummary) summary.textContent = nextSummary;
    });
  };

  const compactComplementaryQuickAddLabels = () => {
    document
      .querySelectorAll('.ag-olfacto-compact-info + product-recommendations .quick-add__submit')
      .forEach((button) => {
        if (button.disabled || button.dataset.agCompactLabel === 'true') return;
        const compactLabel = button.getAttribute('aria-haspopup') === 'dialog' ? 'Choisir' : 'Ajouter +';
        const labelElement = button.querySelector(
          ':scope > span:not(.sold-out-message):not(.icon-wrap):not(.loading__spinner)'
        );
        if (labelElement) {
          labelElement.textContent = compactLabel;
          button.dataset.agCompactLabel = 'true';
          return;
        }
        const labelNode = Array.from(button.childNodes).find(
          (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
        );
        if (!labelNode) return;
        labelNode.textContent = `${compactLabel} `;
        button.dataset.agCompactLabel = 'true';
      });
  };

  const prepareVariantRails = () => {
    const mainProductInfo = getMainProductInfo();
    if (!mainProductInfo) return;

    mainProductInfo
      .querySelectorAll('variant-selects > .ag-variant-rail')
      .forEach((fieldset) => {
        const track = fieldset.querySelector(':scope > .ag-variant-scroll-track');
        if (!track) return;
        if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
          track.style.scrollSnapType = 'none';
        }
        if (track.dataset.agRailReady === 'true') return;
        track.dataset.agRailReady = 'true';

        const markInteraction = () => {
          if (Math.abs(track.scrollLeft) > 8) fieldset.classList.add('is-interacted');
        };

        track.addEventListener('scroll', markInteraction, { passive: true });
        track.addEventListener('pointerdown', () => fieldset.classList.add('is-interacted'), { passive: true });
        track.addEventListener('touchstart', () => fieldset.classList.add('is-interacted'), { passive: true });
      });
  };

  const restoreSelectedVariantRails = () => {
    const mainProductInfo = getMainProductInfo();
    if (!mainProductInfo) return;

    mainProductInfo
      .querySelectorAll('variant-selects > .ag-variant-rail')
      .forEach((fieldset) => {
        const track = fieldset.querySelector(':scope > .ag-variant-scroll-track');
        if (!track || !['auto', 'scroll'].includes(getComputedStyle(track).overflowX)) return;
        if (fieldset.classList.contains('is-interacted')) return;

        const inputs = Array.from(track.querySelectorAll('input[type="radio"]'));
        if (inputs.length <= 4) return;

        const checkedInput = inputs.find((input) => input.checked);
        const checkedLabel = checkedInput
          ? Array.from(track.querySelectorAll('label')).find((label) => label.htmlFor === checkedInput.id)
          : null;
        if (!checkedLabel) return;

        const trackRect = track.getBoundingClientRect();
        const labelRect = checkedLabel.getBoundingClientRect();
        const labelStart = labelRect.left - trackRect.left + track.scrollLeft;
        const labelEnd = labelStart + labelRect.width;
        const inset = 8;
        let nextScrollLeft = track.scrollLeft;

        if (labelStart < track.scrollLeft + inset) {
          nextScrollLeft = Math.max(0, labelStart - inset);
        } else if (labelEnd > track.scrollLeft + track.clientWidth - inset) {
          nextScrollLeft = Math.min(
            track.scrollWidth - track.clientWidth,
            labelEnd - track.clientWidth + inset
          );
        }

        if (Math.abs(track.scrollLeft - nextScrollLeft) > 1) {
          track.scrollLeft = nextScrollLeft;
        }
      });
  };

  getScentCards().forEach((card) => {
    card.addEventListener('click', () => {
      const input = findScentInputForCard(card);
      if (!input || input.disabled) return;
      input.click();
      window.setTimeout(syncScentCards, 80);
    });
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('variant-selects input[data-option-name]')) return;
    if (!event.target.closest('product-info[id^="MainProduct-"]')) return;
    window.setTimeout(() => {
      syncScentCards();
      prepareVariantRails();
      restoreSelectedVariantRails();
    }, 120);
  });

  let nativeButtonIsVisible = true;
  let nativeButtonObserver;
  let observedNativeButton;

  const getNativeButton = () => getMainProductInfo()?.querySelector('.product-form__submit');

  const getVisiblePrice = () => {
    const mainPrice = getMainProductInfo()?.querySelector('.price--large');
    if (!mainPrice) return;

    const preferredSelector = mainPrice.classList.contains('price--on-sale')
      ? '.price-item--sale'
      : '.price-item--regular';
    const preferredPrices = Array.from(mainPrice.querySelectorAll(preferredSelector));
    const fallbackPrices = Array.from(mainPrice.querySelectorAll('.price-item--sale, .price-item--regular'));

    return (
      preferredPrices.find((price) => price.offsetParent !== null)?.textContent?.trim() ||
      preferredPrices[0]?.textContent?.trim() ||
      fallbackPrices.find((price) => price.offsetParent !== null)?.textContent?.trim() ||
      fallbackPrices[0]?.textContent?.trim()
    );
  };

  const updateStickyContent = () => {
    if (!stickyBar || !stickyButton) return;
    const nativeButton = getNativeButton();
    const price = getVisiblePrice();

    if (price && stickyPrice) stickyPrice.textContent = price;
    stickyButton.disabled = !nativeButton || nativeButton.disabled;
    stickyButton.textContent = nativeButton?.disabled ? stickyUnavailableLabel : stickyAvailableLabel;
  };

  const updateStickyVisibility = () => {
    if (!stickyBar || window.innerWidth > 749) {
      stickyBar?.classList.remove('is-visible');
      root.classList.remove('ag-sticky-active');
      return;
    }

    const shouldShow = !nativeButtonIsVisible && window.scrollY > 220;
    stickyBar.classList.toggle('is-visible', shouldShow);
    root.classList.toggle('ag-sticky-active', shouldShow);
  };

  const observeNativeButton = () => {
    const nativeButton = getNativeButton();
    if (!nativeButton || nativeButton === observedNativeButton) return;
    nativeButtonObserver?.disconnect();
    observedNativeButton = nativeButton;
    nativeButtonObserver = new IntersectionObserver(
      ([entry]) => {
        nativeButtonIsVisible = entry.isIntersecting;
        updateStickyVisibility();
      },
      { threshold: 0.15 }
    );
    nativeButtonObserver.observe(nativeButton);
  };

  stickyButton?.addEventListener('click', () => {
    const nativeButton = getNativeButton();
    if (nativeButton && !nativeButton.disabled) nativeButton.click();
  });

  document.querySelectorAll('a[href="#guide-des-senteurs"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector('#guide-des-senteurs');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  const productInfo = getMainProductInfo();
  if (productInfo) {
    let updateTimer;
    const productObserver = new MutationObserver(() => {
      window.clearTimeout(updateTimer);
      updateTimer = window.setTimeout(() => {
        syncScentCards();
        compactComplementaryQuickAddLabels();
        prepareVariantRails();
        restoreSelectedVariantRails();
        updateStickyContent();
        observeNativeButton();
      }, 80);
    });
    productObserver.observe(productInfo, { childList: true, subtree: true });
  }

  let railResizeTimer;
  window.addEventListener('scroll', updateStickyVisibility, { passive: true });
  window.addEventListener(
    'resize',
    () => {
      updateStickyVisibility();
      window.clearTimeout(railResizeTimer);
      railResizeTimer = window.setTimeout(() => {
        prepareVariantRails();
      }, 80);
    },
    { passive: true }
  );

  syncScentCards();
  compactComplementaryQuickAddLabels();
  prepareVariantRails();
  restoreSelectedVariantRails();
  updateStickyContent();
  observeNativeButton();
  updateStickyVisibility();
})();
